const defaults = {
  persistedStore: {
    name: 'pnowy.github-stars.store',
  },
};

export default {
  defaults,
};
